import { Thunk } from 'ha/myredux/types';
import { User } from 'ha/services/apiV2/types/User';
import { UpdateUserPayload } from 'ha/services/apiV2/updateUser';
import { AuthLogicActions } from './actions';

const updateUser: (id: number, newValues: UpdateUserPayload) => Thunk =
  (userId, newValues) =>
  (dispatch, _, { apiV2 }) =>
    apiV2.updateUser(userId, newValues).then(newUser => {
      const userData = newUser.data as Partial<User>;

      delete userData.avatarURL;

      return dispatch(AuthLogicActions.updateUser(userData));
    });

export default updateUser;
